// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rd_3","signatureBlock":"Footer_signatureBlock__8bv_w","signature":"Footer_signature__oi26c"};